module.exports = __webpack_public_path__ + "static/media/responsibility-sustainability-old.cf68f843.jpg";